import { Quote } from '@/model/quotesModel';
import { getScalingFactorsForQuote } from '@/util/quoteAdjustment';

export function calculateGapFillPremium(
  quote: Quote,
  totalCost: number,
  projectedCostCoverage: number,
  maxAchievableCoverage: number,
): number {
  const target = Math.min(totalCost, maxAchievableCoverage);
  const linearEstimate = target * (quote.premiumAmount / projectedCostCoverage);

  const { ltc: ltcFactor } = getScalingFactorsForQuote(quote, linearEstimate);
  const bandCorrection = ltcFactor / (linearEstimate / quote.premiumAmount);

  return Math.round(linearEstimate / bandCorrection);
}

export function formatCoveragePercentage(value: number): string {
  return value % 1 < 0.05 ? `${Math.round(value)}` : value.toFixed(1);
}
